
export const openReading = (objectID: string) =>{
    window.open('/desk?reading=["' + objectID + '"]', "_self")
}

export const openWriting = (objectID: string) =>{
    window.open('/desk?writing=' + objectID, "_self" )
}